const ExperienceObj = {exp: [
  {
    title: "Senior Full Stack Developer",
    company: "BNY",
    duration: "Jun 2023 - Present",
    desc: `
      <b>Tech stack: Java 17/21, Spring Boot, Spring Batch, Spring Data JPA, Apache Spark, Angular, Oracle DB, MQ, Microservices</b><br>
      - Primary subject matter expert and end-to-end technical owner for enterprise market-data ingestion, processing vendor data from MQ and files for downstream collateral and clearance operations.<br>
      - Designed an AI-powered vulnerability engineering platform: Rakshak Manager (adopted across 10 applications), Trinetra (application knowledge base), and BatchFix (automated triage, contextual fixes, tests, and merge requests).<br>
      - Remediated 1,000+ security findings across banking applications, including CVEs, SAST findings, authentication and authorization weaknesses, and infrastructure vulnerabilities.<br>
      - Modernized applications through Spring Boot 2.x to 3.x upgrades, Java 17/21 upgrades, TLS-secured MQ migration, MFA, and Spring Security enhancements.<br>
      - Built high-volume Spring Batch, Apache Spark, and shell-based data processing and validation workflows handling millions of records.<br>
      - Used GitHub Copilot, Windsurf, and Claude Code for implementation, debugging, test generation, and developer productivity.<br>
    `
  },
  {
    title: "Full Stack Developer",
    company: "Oracle Financial Services Software",
    duration: "Aug 2021 - Jun 2023",
    desc: `
      <b>Tech stack: Java, JAX-RS, Spring Boot, JavaScript, Knockout.js, Velocity, SQL/PLSQL, Node.js, Express.js</b><br>
      - Developed Open Banking REST APIs for retail and corporate banking and integrated SOAP/REST web services.<br>
      - Implemented features for Liquidity Management and Virtual Account Management products.<br>
      - Developed and optimized data migration scripts for retail, corporate, and open banking systems.<br>
      - Built a Node.js/Express mock server to simulate unavailable external dependencies and unblock development and testing.<br>
      - Delivered customer features and resolved production and on-site issues.<br>
    `
  },
  {
    title: "Bug Bounty Hunter",
    company: "Freelance",
    duration: "May 2018 - Dec 2019",
    desc: `
      - Reported web and Android security vulnerabilities affecting 50+ organizations, including Google.<br>
      - <a href="https://bughunters.google.com/profile/4c9277a0-5d33-4a9c-8221-ed4eec009e14" target="_blank" rel="noopener noreferrer" style="color:white;">Google Bug Hunters profile</a>.<br>
      - <a href="https://bugcrowd.com/manralhemant10" target="_blank" rel="noopener noreferrer" style="color:white;">Bugcrowd profile</a>.<br>
    `
  }
]};
export default ExperienceObj;
